import React, { lazy, Suspense, useEffect, useState } from "react";
import "./productusageview.css";
import NumberAndTextShow from "./NumberAndTextShow";
const Grid = lazy(() => import("animated-grid-lines"));
const LottieAnimation = lazy(() => import("./LottieAnimation"));
const LottieAnimationMobile = lazy(() => import("./LottieAnimationMobile"));

const gridColors = ["#00FFFF"];
function ProductUsageView() {
  const [showMobileLottie, setShowMobileLottie] = useState(false);
  const [wizardIndex, setWizardIndex] = useState(1);
  const [filCircleIndex, setFilCircleIndex] = useState(false);

  useEffect(() => {
    if (window.innerWidth < 768) {
      setShowMobileLottie(true);
    }

    const handleResize = () => {
      if (window.innerWidth < 768) {
        setShowMobileLottie(true);
      } else {
        setShowMobileLottie(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    let timeoutId;

    const interval = setInterval(() => {
      setWizardIndex((prev) => {
        if (prev === 2) {
          setFilCircleIndex(false);
          return 1;
        }

        if (timeoutId) clearTimeout(timeoutId);

        timeoutId = setTimeout(() => {
          setFilCircleIndex(true);
        }, 2700);

        return prev + 1;
      });
    }, 3540);

    return () => {
      clearInterval(interval);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, []);

  return (
    <div className="productusage-container">
      <div className="productusage-wrapper ">
        <div
          className="flexprop "
          style={{
            gap: "3rem",
            flexWrap: "wrap",
            padding: "3vw 0vw",
            position: "relative",
          }}
        >
          <Suspense fallback={<div>...</div>}>
            <Grid
              colors={gridColors}
              speed={15}
              squareSize={80}
              maxLineLength={100}
              lineWidth={0.5}
              gridColor="rgba(255, 255, 255, 0.1)"
              className="ligntning-animation-productusage"
            />
          </Suspense>

          <div className="productusage-headings flexprop">
            <div className="productusage-main-heading">Why choose BeFiSc</div>
            <div className="productusage-sub-heading">
              to streamline your ID verification & KYC process?
            </div>
          </div>
          <div
            className="flexprop"
            style={{
              width: "100vw",
              flexDirection: "row",
              justifyContent: "space-around",
              flexWrap: "wrap",
              gap: "3rem",
              zIndex: "20",
              pointerEvents: "none",
            }}
          >
            <NumberAndTextShow
              bigtext={"150"}
              smalltext={"+"}
              nextrowtext={"APIs"}
            />
            <NumberAndTextShow
              bigtext={"3"}
              smalltext={"sec"}
              nextrowtext={"Avg Response Time"}
            />
            <NumberAndTextShow
              bigtext={"99.9"}
              smalltext={"%"}
              nextrowtext={"Uptime"}
            />
          </div>
        </div>
        <div className="productusage-container-two">
          <div className="productusage-top-background"></div>
          <div className="productusage-view-heading">How it works</div>
          {!showMobileLottie && (
            <div className="productusage-web-view">
              <Suspense fallback={<div>...</div>}>
                <LottieAnimation />
              </Suspense>
            </div>
          )}
          {showMobileLottie && (
            <div className="productusage-mobile-view">
              <Suspense fallback={<div>...</div>}>
                <LottieAnimationMobile />
              </Suspense>
            </div>
          )}
          {/* {LottieAni && (
            <div
              className={`${
                showMobileLottie
                  ? "productusage-mobile-view"
                  : "productusage-web-view"
              }`}
            >
              <Suspense fallback={<div>...</div>}>
                <LottieAni />
              </Suspense>
            </div>
          )} */}
        </div>
        <div className="wizard-statement">
          <div className="wizard">
            <div className="step">
              <div
                className={`circle ${
                  wizardIndex === 1 || wizardIndex === 2 ? "circle-active" : ""
                }`}
              >
                1
              </div>
              <p className="step-text">Request user input</p>
              <div
                style={{ width: "100%" }}
                className={`wizard-line ${
                  wizardIndex === 1 ? "wizard-line-active" : ""
                }`}
              ></div>
            </div>
            <div className="step">
              <div
                className={`circle ${wizardIndex === 2 ? "circle-active" : ""}`}
              >
                2
              </div>

              <p className="step-text">Get it verified</p>
              <div
                className={`wizard-line ${
                  wizardIndex === 2 ? "wizard-line-two-active" : ""
                }`}
              ></div>
            </div>
            <div className="step">
              <div
                className={`circle ${filCircleIndex ? "circle-active" : ""}`}
              >
                3
              </div>
              <p className="step-text">Trigger action instantly</p>
            </div>
          </div>
        </div>
      </div>
      <img
        src="/images/rectangle-curved-svg.png"
        alt="curved-secton"
        style={{ width: "100%", height: "50%" }}
        loading="lazy"
        decoding="async"
      />
    </div>
  );
}

export default React.memo(ProductUsageView);
